import { BaseDto } from '@/shared/dtos/base-dto';

export class BasicEmailMessage extends BaseDto {
    public email !: string;
    public subject !: string;
 } 
